import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { GraphqlService } from '../../services/graphql.service';
import { Router } from '@angular/router';
import { CommonDataService } from '../../services/common-data.service';
import { LocationStrategy } from '@angular/common';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html'
})
export class ArchiveComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  constructor(private location: LocationStrategy, private graphQlService: GraphqlService, private router: Router, private commonDataService: CommonDataService) {
  }

  normalUrl: string = "";
  secUrl: string = "";
  ngOnInit(): void {
    this.firstTimeFlag = true;
    this.commonDataService.showLoader.next(true);
    this.commonDataService.archiveNormalUrl.subscribe(data => { this.normalUrl = data; })
    this.commonDataService.archiveSecUrl.subscribe(data => { this.secUrl = data; })
    if (this.secUrl != "" && this.normalUrl != "") {
      forkJoin(this.graphQlService.GetArchiveList(this.normalUrl), this.graphQlService.GetArchiveList(this.secUrl), this.graphQlService.GetArchiveLabels())
        .subscribe(([fasbdata, secdata, archiveData]) => {
          this.fasbversions = fasbdata; this.secversions = secdata; this.getArchiveLabel(archiveData);
          this.commonDataService.showLoader.next(false);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
    }
    else if (this.secUrl == "" && this.normalUrl != ""){
      forkJoin(this.graphQlService.GetArchiveList(this.normalUrl), this.graphQlService.GetArchiveLabels())
        .subscribe(([fasbdata, archiveData]) => {
          this.fasbversions = fasbdata; this.getArchiveLabel(archiveData);
          console.log(this.fasbversions);
          this.commonDataService.showLoader.next(false);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
    }
    else if (this.secUrl != "" && this.normalUrl == "") {
      forkJoin(this.graphQlService.GetArchiveList(this.secUrl), this.graphQlService.GetArchiveLabels())
        .subscribe(([secdata, archiveData]) => {
          this.secversions = secdata; this.getArchiveLabel(archiveData);
          this.commonDataService.showLoader.next(false);
        }, err => {
          console.log(err);
          this.commonDataService.showLoader.next(false);
        });
    }
    this.commonDataService.breadcrumbPath.subscribe(path => this.breadcrumbPath = path);
  }
  fasbversions: any;
  secversions: any;
  breadcrumbPath: string = "";
  breadcrumbNum: string = "";
  archive_header: string = "";
  archive_body: string = "";
  archive_note: string = "";
  archive_general: string = "";
  archive_version: string = "";
  archive_supersededOn: string = "";
  archive_fasbContent: string = "";
  archive_secContent: string = "";
  archive_noVersionFound: string = "";
  archive_updateNote: string = "";
  getArchiveLabel(data) {
    if (data != "") {
      var labels = data.content.data.labels;
      labels = labels.filter(x => x.key.trim());
      this.archive_header = labels.filter(x => x.key == "archive_header").map(y => y.value);
      this.archive_body = labels.filter(x => x.key == "archive_body").map(y => y.value);
      this.archive_note = labels.filter(x => x.key == "archive_note").map(y => y.value);
      this.archive_general = labels.filter(x => x.key == "archive_general").map(y => y.value);
      this.archive_version = labels.filter(x => x.key == "archive_version").map(y => y.value);
      this.archive_supersededOn = labels.filter(x => x.key == "archive_supersededOn").map(y => y.value);
      this.archive_fasbContent = labels.filter(x => x.key == "archive_fasbContent").map(y => y.value);
      this.archive_secContent = labels.filter(x => x.key == "archive_secContent").map(y => y.value);
      this.archive_noVersionFound = labels.filter(x => x.key == "archive_noVersionFound").map(y => y.value);
      this.archive_updateNote = labels.filter(x => x.key == "archive_updateDateNote").map(y => y.value);
    }
  }
  /* eslint-disable */
  GoToVersion(version) {
    if (version.expiryDate != "") {
      localStorage.setItem("isArchivePage", "true");
      if (this.router.navigateByUrl) {
        this.router.navigateByUrl("/archiveContent/" + version.publicationId + "/" + version.topicId).then(() => {
          this.myEvent.emit();
        });
      }
    }
    else {
      this.myEvent.emit();
    }
  }
  /* eslint-enable */
  addtabindex() {
   
    var items = document.querySelectorAll("div.archive-margin-main>article.specialcase-header> strong");
    if (items != undefined) {
      for (let i = 0; i < items?.length; i++) {
        let element = items[i];
        element.setAttribute("tabIndex", "0");

      }
    }
    var matches = document.querySelectorAll("div>article.archive-Info > div");
    if (matches != undefined) {
      for (let j = 0; j < matches?.length; j++) {
        let element = matches[j];
        element.setAttribute("tabIndex", "0");

      }
    }

    var warningtext = document.querySelectorAll("div.archive-warning-rectangle");
    if (warningtext != undefined) {
      for (let k = 0; k < warningtext?.length; k++) {
        let element = warningtext[k];
        element.setAttribute("tabIndex", "0");

      }
    }

  }
  firstTimeFlag: boolean = true;
  ngAfterViewChecked() {
    if (this.firstTimeFlag) {
      this.addtabindex();
      this.firstTimeFlag = false;
    }
  }
}
